import { z } from "zod";

export const CleanupGaResponseBodySchema = z.string();
export type CleanupGaResponseBodyType = z.infer<
  typeof CleanupGaResponseBodySchema
>;
